import { Entity, OneToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';
import EpisodicProp from '../episodic-props/episodic-prop.entity';
import InventorySatellite from '../inventory-satellites/inventory-satellite.entity';
import PrWrapBox from '../pr-wrap-boxes/pr-wrap-box.entity';

@Entity('prop_storage_locations')
export default class PropStorageLocation extends InventorySatellite {
	static readonly tableName = 'prop_storage_locations';

	@OneToMany(
		(type) => EpisodicProp,
		(episodicProp) => episodicProp.storageLocation
	)
	episodicProps: EpisodicProp[];

	@OneToMany((type) => PrWrapBox, (prWrapBox) => prWrapBox.prStorageLocation)
	prWrapBoxes: PrWrapBox[];

	constructor(props?: GenPartial<PropStorageLocation>) {
		super(props);
	}
}
